import AbstractBuilderFactory from 'components/organisms/players-to-exchange/available-players/builder-factory';

export default class TableBuilderProvider {
    public static provide(sportConfig) {
        const builderFactory = AbstractBuilderFactory.getBuilder(sportConfig.getSport());

        if (sportConfig.isGameTypeShowDown() && sportConfig.isSportGolf()) {
            return builderFactory.createClassicBuilder(sportConfig);
        } else if (sportConfig.isGameTypeClassic()) {
            return builderFactory.createClassicBuilder(sportConfig);
        } else if (sportConfig.isGameTypeTiers()) {
            return builderFactory.createTiersBuilder(sportConfig);
        } else if (sportConfig.isGameTypeShowDown()) {
            return builderFactory.createShowDownBuilder(sportConfig);
        } else if (sportConfig.isGameTypeSingleGame()) {
            return builderFactory.createSingleGameBuilder(sportConfig);
        }

        throw Error('Builder not found. Make sure you are using a valid game type.');
    }
}
